import { useTranslation } from "react-i18next";
import { Guarantee } from "../../../../redux/apiSpecifications/apiPolicies";
import { FormRow } from "../../../../style/form";
import { InputTextStyled } from "../../../../style/Input";
import { RowSpacer } from "../../../../style/containers";
import BranchesSelect from "../Inputs/BranchesSelect";
import { useEffect, useMemo } from "react";
import useFormData from "../../../../hooks/useFormData";
import FormModal from "../../../Modals/FormModal";
import { isNotEmpty } from "../../../../validation/common";

interface IPolicyGuaranteeFormProps {
  policyGuarantee: Guarantee;
  disableForm?: boolean;
  branchesCodesToExclude?: string[];
  onChange?: (value: any, field: string) => void;
}

const PolicyGuaranteeForm = ({
  policyGuarantee,
  disableForm,
  branchesCodesToExclude,
  onChange,
}: IPolicyGuaranteeFormProps) => {
  const { t } = useTranslation();

  const handleOnChange = (value: any, field: string) => {
    if (onChange) {
      // if (["excessAmount", "overdraftAmount"].includes(field)) {
      //   if (value === "") onChange("0", field);
      //   else if (/^\d+(\,\d{0,})?$/.test(value)) {
      //     console.info(value, "xxx");
      //     if (
      //       value.length === 2 &&
      //       value.startsWith("0") &&
      //       !value.endsWith(",")
      //     ) {
      //       onChange(value.substring(1), field);
      //     } else {
      //       onChange(value, field);
      //     }
      //   }
      // } else {
      //   onChange(value, field);
      // }
      if (["excessAmount", "overdraftAmount"].includes(field)) {
        if (value === "") onChange("0", field);
        else if (/^\d+(\,\d{0,})?$/.test(value)) {
          if (
            value.length === 2 &&
            value.startsWith("0") &&
            !value.endsWith(",")
          ) {
            onChange(value.substring(1), field);
          } else {
            onChange(value, field);
            // onChange(value.replace(",","."), field);
          }
        } else {
          onChange("0", field);
        }
        // if (value === "") onChange("0", field);
        // else if (
        //   value.length === 2 &&
        //   value.startsWith("0") &&
        //   !value.endsWith(",")
        // ) {
        //   onChange(value.substring(1), field);
        // } else if (/^\d+(\,\d{0,})?$/.test(value)) {
        //   onChange(value, field);
        // }
      } else {
        onChange(value, field);
      }
    }
  };

  return (
    <FormRow>
      <BranchesSelect
        value={policyGuarantee.branch}
        required={true}
        branchesCodesToExclude={branchesCodesToExclude}
        onChange={(value) => handleOnChange(value, "branch")}
      />

      <RowSpacer />

      <InputTextStyled
        label={t("LABELS.excess-amount")}
        placeholder={t("PLACEHOLDERS.excess-amount")}
        required={true}
        value={policyGuarantee.excessAmount}
        onChange={(value) => handleOnChange(value, "excessAmount")}
        disabled={disableForm}
      />

      <RowSpacer />

      <InputTextStyled
        label={t("LABELS.overdraft-amount")}
        placeholder={t("PLACEHOLDERS.overdraft-amount")}
        required={true}
        value={policyGuarantee.overdraftAmount}
        onChange={(value) => handleOnChange(value, "overdraftAmount")}
        disabled={disableForm}
      />
    </FormRow>
  );
};

export default PolicyGuaranteeForm;

interface IPolicyGuaranteeModalProps {
  open: boolean;
  policyGuarantee?: Guarantee;
  branchesCodesToExclude?: string[];
  onCancel: () => void;
  onConfirm: (policyGuarantee: Guarantee) => void;
}

export const PolicyGuaranteeModal = ({
  open,
  policyGuarantee,
  branchesCodesToExclude,
  onCancel,
  onConfirm,
}: IPolicyGuaranteeModalProps) => {
  const {
    formData: _policyGuarantee,
    setFormData: setPolicyGuarantee,
    onChangeFormData: onChangePolicyGuarantee,
  } = useFormData<Guarantee>();

  useEffect(() => {
    if (open) {
      setPolicyGuarantee(policyGuarantee);
    }
  }, [open]);

  const handleOnConfirmPolicyGuarantee = () => {
    onConfirm({ ..._policyGuarantee! });
  };

  const isPolicyGuaranteeValid = useMemo(() => {
    if (_policyGuarantee === undefined) return false;

    const { branch, excessAmount, overdraftAmount } = _policyGuarantee;

    return (
      isNotEmpty(branch) &&
      isNotEmpty(excessAmount?.toString()) &&
      isNotEmpty(overdraftAmount?.toString())
    );
  }, [_policyGuarantee]);

  return (
    <FormModal
      open={open}
      isConfirmButtonDisabled={!isPolicyGuaranteeValid}
      width={900}
      onCancel={onCancel}
      onConfirm={handleOnConfirmPolicyGuarantee}
    >
      <>
        {_policyGuarantee && (
          <PolicyGuaranteeForm
            policyGuarantee={_policyGuarantee}
            branchesCodesToExclude={branchesCodesToExclude}
            onChange={onChangePolicyGuarantee}
          />
        )}

        {/* <pre>{JSON.stringify(_policyGuarantee, null, 2)}</pre> */}
      </>
    </FormModal>
  );
};
